module.exports = new __parcel__URL__("text-fields-b.f0dea3e1.png").toString();